import styled from 'styled-components'
import { shouldForwardProp } from 'helpers'

type CollapsibleProps = {
    isExpanded: boolean
}

export const StyledCollapsible = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<CollapsibleProps>(['isExpanded'], prop),
})<CollapsibleProps>`
    position: relative;
    width: 100%;
    max-height: ${({ isExpanded }) => (isExpanded ? 'auto' : '0')};
    opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
    overflow: hidden;
    transition: opacity 0.2s ease-in-out;
`
